import store from "../../../../store";
import {SQFT_VIEW_MODE} from "../../constants";
import {CabinetsSet, CountertopPositions} from "../sqftCabinetsDataMapper";
import SqftStore from "../../components/canvas/store/sqftStore";
import {loaderDisable, loaderEnable} from "../../../ui/loaderView";

export const reloadShapesIn3DMode = async (shapes = []) => {
  loaderEnable();

  const reduxState    = store.getState();
  const SQFTViewMode  = reduxState.sqftState.SQFTViewMode;
  const framedDoors   = SQFTViewMode === SQFT_VIEW_MODE.threeDModeFramed;
  const shapeIds      = shapes.map(shape => shape.id);

  let positions = await CabinetsSet.prepareCabinetsPositions(framedDoors);
  positions = positions.filter(position => shapeIds.includes(position.shapeId));
  await SqftStore.viewGL.modelsLoader.reloadModels('cabinets', positions);

  loaderDisable();
};

export const reloadCountertopsIn3DMode = async (shapes) => {
  loaderEnable();

  const shapeIds = shapes.map(shape => shape.id);
  let positions  = await CountertopPositions.prepareCountertopPositions();

  //todo reload countertops only for resized shape
  void shapeIds;
  //positions = positions.filter(position => shapeIds.includes(position.shapeId));

  await SqftStore.viewGL.modelsLoader.removeAllModels('countertops');
  await SqftStore.viewGL.modelsLoader.reloadModels('countertops', positions);

  loaderDisable();
};

export const reloadCountertopsTexturesIn3DMode = async (shapes) => {
  loaderEnable();

  const shapeIds = shapes.map(shape => shape.id);
  let positions  = await CountertopPositions.prepareCountertopPositions();

  //todo reload countertops only for resized shape
  void shapeIds;
  //positions = positions.filter(position => shapeIds.includes(position.shapeId));
  await SqftStore.viewGL.modelsLoader.loaders.countertops.loader.reloadTextures(positions);

  loaderDisable();
};
